import { Box, Grid, useTheme } from "@mui/material";

const SlideSectionText = ({ children, size, borderRight, noPadding }) => {
  const theme = useTheme();

  return (
    <Grid
      size={size}
      width={!size ? "100%" : undefined}
      sx={{
        px: 1,
        position: "relative",
        ...(noPadding ? { padding: 0 } : {}),
      }}
    >
      {children}
      {borderRight && (
        <Box
          sx={{
            position: "absolute",
            top: "0",
            right: theme.spacing(-1), // Décalage de la bordure à droite
            width: "1px",
            height: "100%",
            backgroundColor: "#ccc", // Bordure noire
          }}
        />
      )}
    </Grid>
  );
};

export default SlideSectionText;
